import { render } from "./LeaderboardView.vue?vue&type=template&id=56f4691f&scoped=true&ts=true"
import script from "./LeaderboardView.vue?vue&type=script&lang=ts"
export * from "./LeaderboardView.vue?vue&type=script&lang=ts"

import "./LeaderboardView.scss?vue&type=style&index=0&id=56f4691f&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f4691f"]])

export default __exports__